export default "__VITE_ASSET__BcdoX5vV__"